import React, {Component} from 'react';
import './IconesUtilizados.css';

import head from '../../assets/icons/iconfinder_b-27_4229861.svg';
import poderoso from '../../assets/icons/iconfinder_m-28_4230541.svg';
import intenso from '../../assets/icons/fire.png';
import person from '../../assets/icons/person.png'
import otimista from '../../assets/icons/iconfinder_b-91_4230288.svg';
import precavido from '../../assets/icons/iconfinder_Vector-icons_39_1041628.svg';
import whatsapp from '../../assets/icons/iconfinder_whatsapp_115679.svg';
import analítico from '../../assets/icons/iconfinder_search_461380.svg';
import mediador from '../../assets/icons/iconfinder_Meditation_4042272.svg';
import vencedor from '../../assets/icons/iconfinder_medal_1118195.svg';
import perfeccionista from '../../assets/icons/iconfinder_diamond_430094.svg';
import ajudante from '../../assets/icons/iconfinder_property-agent-005_1851811.svg';
import iconNext from '../../assets/icons/iconfinder_next_black_308956.svg';
import cauteloso from '../../assets/icons/iconfinder_scales_296210.png';
import influente from '../../assets/icons/iconfinder_14_leader_target_achievement_business_3964125.png';
import casa from '../../assets/icons/iconfinder_Streamline-18_185038.svg';

export default class IconesUtilizados extends Component {
    render() {
        return (
            <div className="icones-utilizados">
                <h1>Ícones Utilizados</h1>
                <div className="icons-list">

                    <div className="icons-container">
                        <img src={head} alt="cabeça"/>
                        <div className="data-container">
                            <h2 className="author">MD BADSHA MEAH</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/4229861/head_jigsaw_mind_puzzle_solution_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={poderoso} alt="poderoso"/>
                        <div className="data-container">
                            <h2 className="author">MD BADSHA MEAH</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/4230541/business_success_winner_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={intenso} alt="intenso"/>
                        <div className="data-container">
                            <h2 className="author">Ballo Marco</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/513726/black_element_fire_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <span className="free-license">Livre para uso<br/>comercial</span>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={person} alt="pessoa"/>
                        <div className="data-container">
                            <h2 className="author">Ionicons</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/211794/person_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://opensource.org/licenses/MIT" target="_blank" rel="noopener noreferrer">MIT License</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={otimista} alt="otimista"/>
                        <div className="data-container">
                            <h2 className="author">MD BADSHA MEAH</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/4230288/analytics_career_growth_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={precavido} alt="precavido"/>
                        <div className="data-container">
                            <h2 className="author">iconnice studio</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/1041628/protection_safe_security_shield_icon_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <span className="free-license">Livre para uso<br/>comercial</span>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={casa} alt="endereço"/>
                        <div className="data-container">
                            <h2 className="author">Webalys</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/185038/home_house_streamline_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <span className="free-license">Livre para uso<br/>comercial</span>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={whatsapp} alt="whatsapp"/>
                        <div className="data-container">
                            <h2 className="author">Webalys</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/115679/whatsapp_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={analítico} alt="analítico"/>
                        <div className="data-container">
                            <h2 className="author">Alex Talalueva</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/461380/find_glass_look_search_view_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={mediador} alt="mediador"/>
                        <div className="data-container">
                            <h2 className="author">Chanut is Industries</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/4042272/healthy_life_meditation_peace_pose_relaxation_spirituality_yoga_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={vencedor} alt="vencedor"/>
                        <div className="data-container">
                            <h2 className="author">Stefania Servidio</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/1118195/award_gold_medal_star_winner_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={perfeccionista} alt="perfeccionista"/>
                        <div className="data-container">
                            <h2 className="author">Bogdan Rosu Creative</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/430094/diamond_ruby_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <span className="free-license">Livre para uso<br/>comercial</span>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={ajudante} alt="ajudante"/>
                        <div className="data-container">
                            <h2 className="author">Gan Khoon Lay</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/1851811/agent_agreement_business_contract_deal_handshake_property_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={iconNext} alt="próximo / anterior"/>
                        <div className="data-container">
                            <h2 className="author">Ivan Boyko</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/308956/arrow_next_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">Creative Commons</a>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container">
                        <img src={cauteloso} alt="balança"/>
                        <div className="data-container">
                            <h2 className="author">Last Call Media Inc</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/296210/balance_court_government_justice_law_measure_scale_scales_weigh_weighing_weight_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <span className="free-license">Livre para uso<br/>comercial</span>
                            </p>
                        </div>
                    </div>

                    <div className="icons-container .leader">
                        <img src={influente} alt="líder" id="leader"/>
                        <div className="data-container">
                            <h2 className="author">IconMarketPK</h2>
                            <p className="source">
                                Fonte: <a href="https://www.iconfinder.com/icons/3964125/achievement_business_leader_target_icon" target="_blank" rel="noopener noreferrer">ICONFINDER</a>
                            </p>
                            <p className="license">
                                Licença: <span className="free-license">Livre para uso<br/>comercial</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}